import {
    Datagrid,
    List,
    Edit,
    Show,
    SimpleShowLayout,
    TextField,
    Pagination,
    ImageField,
    Create,
    BooleanField,
    BooleanInput,
    ArrayField,
    ChipField,
    SingleFieldList,
    DateInput,
} from "react-admin";
import { SimpleForm, TextInput } from "react-admin";
import {
    ConfirmOnRecordButton,
    LongDateField,
    MediaUploadField,
    ShortDateField,
    VideoPlayerField,
} from "./customFields";

const socialPostFilters = [<TextInput source="q" label="Search" alwaysOn />];

export const SocialPostList = () => (
    <List
        filters={socialPostFilters}
        perPage={50}
        pagination={<Pagination rowsPerPageOptions={[25, 50, 100, 200]} />}
        sort={{ field: "created_at", order: "DESC" }}
    >
        <Datagrid rowClick="show" bulkActionButtons={false}>
            <TextField source="title" />
            <ImageField source="thumbnail_url" title="SocialPost image" label="Image" sortable={false} />
            <BooleanField source="is_public" />
            <ShortDateField source="created_at" label="Created at" />
        </Datagrid>
    </List>
);

export const SocialPostShow = () => (
    <Show>
        <SimpleShowLayout>
            <h2>SocialPost</h2>

            <ArrayField source="status" label="Processing Status">
                <SingleFieldList linkType={false}>
                    <ChipField source="name" size="small" />
                </SingleFieldList>
            </ArrayField>
            <TextField source="title" />
            <ImageField source="image_url" title="SocialPost image" label="Image" sortable={false} />
            <VideoPlayerField />

            <ConfirmOnRecordButton
                confirmTitle="Reencode video"
                confirmBody="Are you sure you want to reencode video?"
                url="/cms/social_posts/{id}/reencode_video"
                text="Reencode video"
            />
            <LongDateField source="date" />
            <LongDateField source="created_at" label="Created at" />
        </SimpleShowLayout>
    </Show>
);

export const SocialPostCreate = () => (
    <Create>
        <SimpleForm>
            <h2>Create SocialPost</h2>

            <TextInput source="title" sx={{ width: 500 }} />
            <BooleanInput source="is_public" />
            <MediaUploadField mediaType="image" />
            <MediaUploadField mediaType="video" />
            <TextInput source="url" sx={{ width: 500 }} />
            <DateInput source="date" label="date" />
        </SimpleForm>
    </Create>
);

export const SocialPostEdit = () => (
    <Edit mutationMode="pessimistic">
        <SimpleForm>
            <h2>Edit SocialPost</h2>

            <TextInput source="title" sx={{ width: 500 }} />
            <BooleanInput source="is_public" />
            <MediaUploadField mediaType="image" />
            <MediaUploadField mediaType="video" />
            <TextInput source="url" sx={{ width: 500 }} />
            <DateInput source="date" label="date" />
        </SimpleForm>
    </Edit>
);
